var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconsPaypalSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.12 6.178h6.36c3.414 0 4.699 1.687 4.5 4.165-.328 4.09-2.863 6.354-6.224 6.354h-1.698c-.46 0-.771.298-.896 1.105l-.72 4.693c-.048.305-.212.481-.458.505H7.988c-.376 0-.509-.28-.41-.887l2.436-15.046c.095-.602.433-.889 1.106-.889z",
    fill: "#009EE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.143 1h6.366c1.792 0 3.92.056 5.34 1.281.951.819 1.45 2.121 1.335 3.524-.39 4.743-3.297 7.4-7.197 7.4H9.848c-.535 0-.888.346-1.04 1.282l-.876 5.446c-.057.352-.213.56-.492.586H3.512c-.435 0-.59-.32-.476-1.028L5.859 2.035C5.972 1.333 6.37 1 7.143 1z",
    fill: "#113984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.9 13.934 1.112-6.867c.097-.602.435-.89 1.108-.89h6.36c1.051 0 1.903.16 2.57.456-.639 4.223-3.437 6.568-7.101 6.568H9.815c-.42.001-.729.206-.914.733z",
    fill: "#172C70"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPaypalSmall);
export default __webpack_public_path__ + "static/media/icons-paypal-small.979d2faa6f880b88ca4a42eaaef4782f.svg";
export { ForwardRef as ReactComponent };